module.exports = __webpack_public_path__ + "static/media/header_logo_alt.4fa3e3f0.png";